export const ESTADOS_VIAJE = {
  EN_EDICION: 'EN_EDICION',
  PUBLICADO: 'PUBLICADO',
  PAGADO: 'PAGADO',
  CERRADO: 'CERRADO',
  HISTORICO: 'HISTORICO',
};

export const ESTADOS_VIAJE_ORDER = {
  EN_EDICION: 0,
  PUBLICADO: 1,
  EN_PAGO: 2,
  PAGADO: 3,
  CERRADO: 4,
  PEDIDO_REALIZADO: 5,
  HISTORICO: 6,
};

export const TIPOS_PAGO = {
  INTERNO: 'INTERNO',
  EXTERNO: 'EXTERNO',
  SIN_PAGO: 'SIN_PAGO',
};

export const QUIEN_PAGA = {
  QUIEN_PAGA_UNICO_PAGADOR: 'UNICO_PAGADOR',
  QUIEN_PAGA_PLAZA_A_PLAZA: 'PLAZA_A_PLAZA',
};

export const HITOS_PAGO_TIPOCANTIDAD = {
  FIJO: 'FIJO',
  PORCENTAJE: 'PORCENTAJE',
  RESTANTE: 'RESTANTE',
};


export const ESTADOS_INVITACION_GRUPO = {
  PENDIENTE: 'PENDIENTE',
  ACEPTADA: 'ACEPTADA',
  RECHAZADA: 'RECHAZADA'
};